export default "__VITE_ASSET__b74cf263__"